module.exports = __webpack_public_path__ + "img/fushimi-HP-017.648ec11f.jpg";